import React from "react";
import {useSelector,useDispatch} from 'react-redux';
import {useEffect,useState} from 'react';
import LoginFormLegacy from './components/loginFormLegacy.js';
import LoginAdthriveForm from './components/loginAdthriveForm.js';
import Footer from './components/common/footer.js';
import Brief from './components/brief';
import DashboardLegacy from './components/dashboardLegacy.js'
import DashboardAdthrive from './components/dashboardAdthrive.js'
import LoadBriefForm from './components/loadBriefForm.js';
import LoginChooseSite from './components/LoginChooseSite.js';
import AdblockMessage from './components/adblockMessage.js'
import {getCustomStyle, setupPostSaveCallbackHook} from './utility';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import {Box} from "@material-ui/core";
import {Route,useHistory} from 'react-router-dom';
import Snackbar from '@material-ui/core/Snackbar';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';
import * as briefActions from './actions/briefActions';
import * as userActions from './actions/authenticationActions';
import * as currentPageActions from './actions/currentPageActions';
import CssBaseline from '@material-ui/core/CssBaseline';
import ScopedCssBaseline from '@material-ui/core/ScopedCssBaseline';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faHeading, faExternalLinkAlt, faTimes } from '@fortawesome/free-solid-svg-icons' // don't forget, you must add it to "library.add" too
import _ from 'lodash';
import store from 'store';

const graphikRegular = {
  fontFamily: 'Graphik',
  fontStyle: 'normal',
  fontDisplay: 'swap',
  fontWeight: 400,
  src: `
    url(https://storage.googleapis.com/usetopic/assets/GraphikRegular.woff) format('woff2')
  `
};

const graphikBold = {
  fontFamily: 'Graphik',
  fontStyle: 'normal',
  fontDisplay: 'swap',
  fontWeight: 700,
  src: `
    url(https://storage.googleapis.com/usetopic/assets/GraphikBold.woff) format('woff2')
  `
};

const theme = createMuiTheme({
    typography: {
      fontFamily: 'Graphik, Arial',
    },
    overrides: {
      MuiCssBaseline: {
        '@global': {
          '@font-face': [graphikRegular, graphikBold],
        },
      },
      MuiPaper: {
        elevation1:{
          'box-shadow': '0px 2px 5px 0px #3838382e'
        }
      }
    },
    palette: {
      primary: {
        main: '#3f4b5b'
      },
    }
});


function App(props){
  const dispatch = useDispatch();
  const history = useHistory();
  const loggedInState = useSelector(state => state.auth);
  const briefsState = useSelector(state => state.briefs);
  const currentPage = useSelector(state => state.currentPage);
  const [snackbarState, setSnackbarState] = React.useState(false);
  const [snackBarMessage, setSnackBarMessage] = React.useState("");

  if(props.isClassic){
    window.isClassicEditor = true;
  } else{
    // for block editor, if publisher hits publish, update the permalink state
    // so that publishers can complete the brief after publishing
    setupPostSaveCallbackHook(() => {
      console.log('POST SAVE CALLBACK HOOK');
      dispatch(currentPageActions.fetchCurrentPagePermalink());
    });
  }

  library.add(faHeading, faExternalLinkAlt, faTimes);

  // onMount, log user in automatically if they have tokens
  useEffect(() => {
    let topicToken = store.get('topicToken');
    let adthriveAuthObj = store.get('adthriveAuthObj');
    let adthriveToken = adthriveAuthObj && adthriveAuthObj.token;
    let adthriveActiveSite = store.get('adthriveActiveSite');

    if(topicToken){
      // user is logged into Topic via localStorage
      if(!loggedInState.isLoggedIn){
        // update redux with localStorage token
        dispatch(userActions.loginUserSuccess(topicToken));
      }
      // load briefs
      dispatch(briefActions.getBriefs(topicToken));
      history.push('/dashboard_legacy');
    } else if(adthriveToken){
      // user is logged into AdThrive via localStorage
      if(!adthriveActiveSite){
        // user has not chosen their active site
        history.push('/choose_site')
      } else{
        // user has chosen their active site
        dispatch(userActions.setActiveSite(adthriveActiveSite));
        if(!loggedInState.isLoggedInAdthrive){
          // update redux with localStorage token
          dispatch(userActions.loginAdthriveUserSuccess(adthriveAuthObj.token, adthriveAuthObj.name, adthriveAuthObj.email));
        }
        // load briefs
        dispatch(briefActions.getAdthriveBriefs());
        history.push('/dashboard_adthrive');
      }
    } else{
      let previousURLObject = (localStorage.previousURLObject && JSON.parse(localStorage.previousURLObject))? JSON.parse(localStorage.previousURLObject) : {};
      if(currentPage.postId && previousURLObject[currentPage.postId]){
        history.push('/load_brief');
      }else{
        // not logged in via localStorage & no previously loaded brief for the post, so go to default view
        history.push('/login_adthrive');
      }
    }
  }, []);

  // onMount, check to see if user has adblocking turned on
  useEffect(() => {
    fetch('https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js', {
      method: 'GET'
    }).then(function(response) {
        console.log('no adblock present');
    })
    .catch(function(error) {
      console.log('adblock is present', error);
      history.push('/adblock')
    });
  }, []);

  // fetch permalink from backend
  useEffect(() => {
    if(currentPage.postId === null && !currentPage.isLoading){
      dispatch(currentPageActions.fetchCurrentPagePermalink());
    }
  });

  // identify users if the loggedInState has changed
  useEffect(() => {
    if(loggedInState.email){
      window.AP.tanalytics.identify({
        email: loggedInState.email,
        name: loggedInState.name,
        legacy: false
      })
    }
  }, [loggedInState]);

  // if token expires or becomes malformed, loggedInState changes to false and 
  // this sends the app to the correct view
  useEffect(() => {
    let adthriveAuthObj = store.get('adthriveAuthObj');
    let adthriveToken = adthriveAuthObj && adthriveAuthObj.token;
    if(loggedInState.isLoggedInAdthrive === false && !adthriveToken){
      history.push('/login_adthrive');
    }
  }, [loggedInState.isLoggedInAdthrive]);

  useEffect(() => {
    jQuery('#post-body-content, #normal-sortables, .notice').addClass('usetopic-lesswidth');
    jQuery(window).trigger('resize');

    return function cleanup(){
      jQuery('#post-body-content, #normal-sortables, .notice').removeClass('usetopic-lesswidth');
      jQuery(window).trigger('resize');
    }
  })

  const openSnackbar = (message) => {
    setSnackBarMessage(message);
    setSnackbarState(true);
  }

  const closeTopicDialog = () => {
    jQuery('#usetopicData').css("display","none");
    jQuery('#post-body-content, #normal-sortables, .notice').removeClass('usetopic-lesswidth');
    jQuery(window).trigger('resize');
  }    

  return(
      <MuiThemeProvider theme={theme}>
        <ScopedCssBaseline style={{minHeight: '100%', display: 'flex', flexDirection: 'column'}}>
        {getCustomStyle("#sidebar")}
        {props.isClassic && <div style={{position: 'relative',padding:'1rem',fontSize:'1rem',color:'#0a1f44',fontWeight:'500', display: 'flex'}}>
          <div style={{flexGrow: 1}}>
            Topic SEO Content Optimization Tool
          </div>
          <div onClick={() => { closeTopicDialog() }} style={{cursor:'pointer'}}><FontAwesomeIcon icon="times" style={{fontSize: '1rem', color:'0a1f44',fontWeight:'500'}} /></div>
        </div>}
        <Box className="topic-wp-plugin" style={{background:'rgb(249, 249, 249)', minHeight:'100%', flexGrow: '1'}}>
          <Route exact path="/">
            <div></div>
          </Route>
          <Route exact path="/dashboard_legacy">
            <DashboardLegacy Briefs={briefsState}/>
          </Route>
          <Route exact path="/dashboard_adthrive">
            <DashboardAdthrive Briefs={briefsState} />
          </Route>
          <Route exact path="/login_adthrive">
            <LoginAdthriveForm />
          </Route>
          <Route exact path="/choose_site">
            <LoginChooseSite />
          </Route>
          <Route exact path="/load_brief">
            <LoadBriefForm openSnackbar={openSnackbar}/>
          </Route>
          <Route exact path="/brief/:id">
            <Brief Briefs={briefsState} openSnackbar={openSnackbar}/>
          </Route>
          <Route exact path="/login_legacy">
            <LoginFormLegacy openSnackbar={openSnackbar}/>
          </Route>
          <Route exact path="/adblock">
            <AdblockMessage />
          </Route>
          <Snackbar
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'right',
            }}
            open={snackbarState}
            autoHideDuration={6000}
            onClose={()=>(setSnackbarState(false))}
            message={snackBarMessage}
            action={
              <React.Fragment>
                <IconButton size="small" aria-label="close" color="inherit" onClick={()=>(setSnackbarState(false))}>
                  <CloseIcon fontSize="small" />
                </IconButton>
              </React.Fragment>
            }
          />
        </Box>
        <Footer/>
        </ScopedCssBaseline>
    </MuiThemeProvider>
  );
}

export default App
